import { Popup as PopupOld } from '@approvalmax/ui';
import { Popup } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { QBooksCounterpartyCreationPopupContent } from 'pages/requestForm/containers/qbooks/QBooksCounterpartyCreationPopupContent/QBooksCounterpartyCreationPopupContent';
import { qaPrefix as qaPrefixQBooksCounterpartyCreation } from 'pages/requestForm/containers/qbooks/QBooksCounterpartyCreationPopupContent/QBooksCounterpartyCreationPopupContent.constants';
// FIXME: We can't import from other pages.
import { cancelActivePopup as cancelActivePopupRequestList } from 'pages/requestList/actions';
import { EditWatchersPopupContent } from 'pages/requestList/components/EditWatchersPopupContent/EditWatchersPopupContent';
import EditWatchersPopupOld from 'pages/requestList/components/EditWatchersPopupOld/EditWatchersPopup';
import { EDIT_WATCHERS_POPUP } from 'pages/requestList/reducers/page/activePopup/editWatchersPopupReducer';
import { getActivePopupId as getActivePopupIdRequestList } from 'pages/requestList/selectors/pageSelectors';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useUserBetaFeatures } from 'shared/hooks';

import { cancelActivePopup } from '../../actions';
import { QBooksCounterpartyCreationPopup } from '../../containers/qbooks/QBooksCounterpartyCreationPopup/QBooksCounterpartyCreationPopup';
import SaveAndApprovePopup from '../../containers/SaveAndApprovePopup';
import { XeroCreateContactPopup as XeroCreateContactOldPopup } from '../../containers/xero/XeroCreateContactOldPopup/XeroCreateContactPopup';
import { XeroCreateContactPopup } from '../../containers/xero/XeroCreateContactPopup/XeroCreateContactPopup';
import { QBOOKS_CUSTOMER_CREATION_POPUP } from '../../reducers/page/activePopup/qBooksCustomerCreationPopupReducer';
import { QBOOKS_CONTACT_CREATION_POPUP } from '../../reducers/page/activePopup/qBooksVendorCreationPopupReducer';
import { SAVE_AND_APPROVE_POPUP } from '../../reducers/page/activePopup/saveAndApprovePopupReducer';
import { XERO_CONTACT_CREATION_POPUP } from '../../reducers/page/activePopup/xeroContactCreationPopupReducer';
import { getActivePopupId, getRequest } from '../../selectors/pageSelectors';
import { SaveAndApprovePopupContent } from '../SaveAndApprovePopupContent/SaveAndApprovePopupContent';
import { messages } from './Popups.messages';

export const Popups = memo(() => {
    const dispatch = useDispatch();

    const activePopupId = useSelector(getActivePopupId);
    const activePopupIdRequestList = useSelector(getActivePopupIdRequestList);

    const {
        isBelgradeUIWatchers,
        isBelgradeUIXeroCreateContactPopup,
        isBelgradeUISaveAndApprovePopup,
        isBelgradeUIQBooksVendorCreationPopup,
    } = useUserBetaFeatures();

    const request = useSelector(getRequest);

    const titleCreateContactPopup =
        request.integrationCode &&
        [domain.IntegrationCode.XeroQuote, domain.IntegrationCode.XeroInvoice].includes(request.integrationCode)
            ? messages.newCustomer
            : messages.newContact;

    const handleCancelActivePopup = useCallback(() => {
        dispatch(cancelActivePopup());
    }, [dispatch]);

    const handleCancelActivePopupRequestList = useCallback(() => {
        dispatch(cancelActivePopupRequestList());
    }, [dispatch]);

    const handleWatchersPopupToggle = useCallback(
        (open: boolean) => !open && handleCancelActivePopupRequestList(),
        [handleCancelActivePopupRequestList]
    );

    return (
        <>
            {isBelgradeUIWatchers ? (
                <Popup
                    open={activePopupId === EDIT_WATCHERS_POPUP}
                    preventAutoClose
                    onToggle={handleWatchersPopupToggle}
                >
                    <EditWatchersPopupContent />
                </Popup>
            ) : (
                <PopupOld
                    isOpen={activePopupIdRequestList === EDIT_WATCHERS_POPUP}
                    disableAutoClose
                    onRequestClose={handleCancelActivePopupRequestList}
                >
                    <EditWatchersPopupOld />
                </PopupOld>
            )}

            {isBelgradeUISaveAndApprovePopup ? (
                <Popup open={activePopupId === SAVE_AND_APPROVE_POPUP} onClose={handleCancelActivePopup}>
                    <SaveAndApprovePopupContent />
                </Popup>
            ) : (
                <PopupOld isOpen={activePopupId === SAVE_AND_APPROVE_POPUP} onRequestClose={handleCancelActivePopup}>
                    <SaveAndApprovePopup />
                </PopupOld>
            )}

            {isBelgradeUIXeroCreateContactPopup ? (
                <Popup open={activePopupId === XERO_CONTACT_CREATION_POPUP} onClose={handleCancelActivePopup}>
                    <XeroCreateContactPopup title={titleCreateContactPopup} />
                </Popup>
            ) : (
                <PopupOld
                    isOpen={activePopupId === XERO_CONTACT_CREATION_POPUP}
                    onRequestClose={handleCancelActivePopup}
                >
                    <XeroCreateContactOldPopup title={titleCreateContactPopup} />
                </PopupOld>
            )}

            {isBelgradeUIQBooksVendorCreationPopup ? (
                <Popup
                    open={
                        activePopupId === QBOOKS_CONTACT_CREATION_POPUP ||
                        activePopupId === QBOOKS_CUSTOMER_CREATION_POPUP
                    }
                    onClose={handleCancelActivePopup}
                    size='large'
                    data-qa={qaPrefixQBooksCounterpartyCreation}
                >
                    <QBooksCounterpartyCreationPopupContent />
                </Popup>
            ) : (
                <PopupOld
                    isOpen={
                        activePopupId === QBOOKS_CONTACT_CREATION_POPUP ||
                        activePopupId === QBOOKS_CUSTOMER_CREATION_POPUP
                    }
                    onRequestClose={handleCancelActivePopup}
                >
                    <QBooksCounterpartyCreationPopup />
                </PopupOld>
            )}
        </>
    );
});

Popups.displayName = 'Popups';
